import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=4bc1bafe&scoped=true&"
import script from "./IconUser.vue?vue&type=script&lang=js&"
export * from "./IconUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1bafe",
  null
  
)

export default component.exports